import React, { Component } from "react";
import { Wrapper, Copy, Title, Row } from "app/NativeComponents/common";

import { openUrl } from "app/NativeActions";
import { store } from "app/store";
import { loadEngine } from "app/NativeActions";
import FrequencySwitch from "./FrequencySwitch";

import Plan from "./Plan";

class EnginePlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      engine: null,
      loading: false
    };
  }

  componentDidMount() {
    this.getData(this.props.engine_slug);
  }

  componentDidUpdate(prevProps) {
    if (this.props.engine_slug !== prevProps.engine_slug) {
      this.getData(this.props.engine_slug);
    }
  }

  getData(engine_slug) {
    if (!this.state.loading) {
      this.setState({
        engine: null,
        loading: true
      });
      loadEngine(engine_slug)
        .then(data => {
          if (data && data.items && data.items.length > 0) {
            this.setState(() => ({ engine: data.items[0] }));
          }
          this.setState(() => ({ loading: false }));
        })
        .catch(err => {
          this.setState(() => ({ loading: false }));
        });
    }
  }

  render() {
    const { engine } = this.state;
    const {
      include_copy,
      include_annual_toggle,
      require_tier = 1
    } = this.props;
    const colors = store.getState().settings.colors;
    const isMobile = store.getState().native.isMobile;

    if (engine && engine.fields && engine.fields.plans) {
      return (
        <Wrapper style={{ alignItems: "center", justifyContent: "center" }}>
          {include_copy ? (
            <Wrapper
              style={{
                padding: 20,
                alignItems: "center",
                justifyContent: "center",
                maxWidth: 500
              }}
            >
              <Title style={{ textAlign: "center" }}>
                {engine.fields.engineTitle}
              </Title>
              <Copy style={{ textAlign: "center" }}>
                {engine.fields.engineDescription}
              </Copy>
            </Wrapper>
          ) : null}

          {include_annual_toggle ? (
            <FrequencySwitch
              onPress={frequency => this.props.onFrequencySwitch(frequency)}
              selected_frequency={this.props.selected_frequency}
            />
          ) : null}

          <Row
            style={{
              alignItems: isMobile ? "center" : "flex-start",
              justifyContent: "center",
              flexDirection: isMobile ? "column" : "now"
            }}
          >
            {engine.fields.plans.map((plan, i) => {
              if (plan.fields.tier >= require_tier) {
                return (
                  <Plan
                    key={i}
                    plan_slug={plan.fields.slug}
                    engine_slug={this.props.engine_slug}
                    colors={colors}
                    onEngineSelect={this.props.onEngineSelect}
                    onDemoPress={this.props.onDemoPress}
                    selected_frequency={this.props.selected_frequency}
                  />
                );
              }
              return null;
            })}
          </Row>
        </Wrapper>
      );
    }
    return null;
  }
}

export default EnginePlans;
